module.exports = __webpack_public_path__ + "static/media/3001.4df0af3a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/ThreeHundred/3001.webp
// module id = 798
// module chunks = 5